<template>
    <b-col cols="12">
        <div class="card-header w-100 d-flex align-items-center">
            <h3 class="card-title">Precios para todas las plazas de esta región</h3>
            <div class="ml-auto">
                <Button @click="volver()">Seleccionar otra región</Button>
            </div>
        </div>
        <div class="card-body p-0 p-md-3">
            <b-row>
                <b-col cols="12">
                    <ContentOrLoading :style="loading ? 'padding: 50px;' : ''">
                        <div v-if="!loading && entradas && general" class="row">
                            <div class="col-12 col-md-3 mt-2 mt-md-0">
                                <strong>Precio general de la región</strong>
                            </div>
                            <div class="col-12 col-md-3 mt-2 mt-md-0">
                                <div>
                                    <label for="precio_taquilla">Precio Taquilla:</label>
                                </div>
                                <multiselect 
                                    v-model="general.precios_taquilla" 
                                    id="general_taquilla" 
                                    placeholder="Precios taquilla" 
                                    label="label_con_gd"
                                    track-by="id" 
                                    :custom-label="labelTaquilla" 
                                    :options="entradas" 
                                    :multiple="true"
                                    data-cy="general-taquilla"
                                />
                            </div>
                            <div class="col-12 col-md-3 mt-2 mt-md-0">
                                <div>
                                    <label for="precios_online">Precios Online:</label>
                                </div>
                                <multiselect 
                                    v-model="general.precios_online" 
                                    id="general_online" 
                                    placeholder="Precios online" 
                                    label="label_sin_gd"
                                    track-by="id" 
                                    :custom-label="labelOnline" 
                                    :options="entradas" 
                                    :multiple="true"
                                    data-cy="general-online"
                                />
                            </div>
                            <div class="col-12 col-md-3 text-right my-auto pt-0 pt-md-4">
                                <button class="btn btn-block" @click.prevent="showModal('avisoConfGeneral')">Guardar</button>
                            </div>
                        </div>
                    </ContentOrLoading>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <div class="text-center alert alert-danger">
                        <span>Este cambio sobreescribirá la configuración de <strong>TODOS</strong> los precios configurados en el apartado de butacas individuales y por sección.</span>
                    </div>
                </b-col>
            </b-row>            
        </div>
        <AvisoConfGeneralModal @close="closeModal" />
    </b-col>
</template>

<script>
    import AvisoConfGeneralModal from './modals/AvisoConfGeneralModal'

    export default {
        props: ['entradas', 'region_id', 'recinto_id'],
        data() {
            return {
                loading: false,
                general: null
            }
        },
        methods: {
            labelTaquilla({
                description,
                price,
                price_management_taquilla_interno,
                price_management_taquilla,
                descripcion,
                precio,
                dia_abonado,
                acompanante_abonado,
                amigo_abonado
            }) {
                description = description ?? descripcion;
                price = price ?? precio;
                var total = parseFloat(price) + price_management_taquilla;

                let abonadoLabel = '';
                if (dia_abonado) {
                    abonadoLabel = ' - Día de abonado';
                } else if (acompanante_abonado) {
                    abonadoLabel = ' - Acompañante de abonado';
                } else if (amigo_abonado) {
                    abonadoLabel = ' - Amigo de abonado';
                }

                if (price_management_taquilla_interno == 1) {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(price).toFixed(2) +
                        '€' +
                        ')'
                    );
                } else {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(total).toFixed(2) +
                        '€' +
                        ')'
                    );
                }
            },
            labelOnline({
                description,
                price,
                price_management_online_interno,
                price_management_online,
                descripcion,
                precio,
                dia_abonado,
                acompanante_abonado,
                amigo_abonado
            }) {
                description = description ?? descripcion;
                price = price ?? precio;
                var total = parseFloat(price) + price_management_online;

                let abonadoLabel = '';
                if (dia_abonado) {
                    abonadoLabel = ' - Día de abonado';
                } else if (acompanante_abonado) {
                    abonadoLabel = ' - Acompañante de abonado';
                } else if (amigo_abonado) {
                    abonadoLabel = ' - Amigo de abonado';
                }

                if (price_management_online_interno == 1) {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(price).toFixed(2) +
                        '€' +
                        ')'
                    );
                } else {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(total).toFixed(2) +
                        '€' +
                        ')'
                    );
                }
            },
            guardarPrecios() {
                this.loading = true;

                let confGeneral = JSON.parse(JSON.stringify(this.general));

                if (confGeneral.precios_online && confGeneral.precios_online.length > 0) {
                    confGeneral.precios_online = confGeneral.precios_online.map(precio => precio.id);
                }

                if (confGeneral.precios_taquilla && confGeneral.precios_taquilla.length > 0) {
                    confGeneral.precios_taquilla = confGeneral.precios_taquilla.map(precio => precio.id);
                }

                let params = {
                    filters: {},
                    data: confGeneral,
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                }

                if (this.region_id) {
                    params.filters.region_id = this.region_id;
                    params.region_id = this.region_id;
                }
            
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.butacas.guardar-precios-general'), params)
                    .then(() => {
                        this.$emit('recargar', null, 'general');
                        this.$toast.success('Precios guardados correctamente!');
                    }).catch(() => {
                        this.$toast.error('Ha ocurrido un error al guardar los precios');
                    }).finally(() => {
                        this.loading = false;
                    });
            },
            showModal(modal) {
                this.$modal.show(modal)
            },
            closeModal(modal, confirmado = false) {
                if (confirmado) {
                    this.guardarPrecios();
                }
                this.$modal.hide(modal)
            },
            getConfGeneral() {
                this.loading = true;

                const params = {
                    filters: {},
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    recinto_id: this.recinto_id
                }
            
                let url = '';
                if (this.region_id) {
                    params.region_id = this.region_id;
                    url = 'back.events.sesiones.settings.zona.general';
                } else {
                    url = 'back.events.sesiones.settings.general';
                }

                this.$store.dispatch(this.config.getVuexAlias(url), params).then(res => {
                    this.general = res.data.data;
                }).catch(() => {
                    console.warn('Error al recuperar la configuración general de la sesión');
                }).finally(() => {
                    this.loading = false;
                });
            },
            volver() {
                this.general = null,
                this.$emit('volver');
            }
        },
        created() {
            this.getConfGeneral();
        },
        components: { AvisoConfGeneralModal }
    }
</script>